module.exports = __webpack_public_path__ + "static/media/twitter-white.2fb54f31.svg";